// frontend/src/pages/CheckoutConfirm.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const CheckoutConfirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [mensaje, setMensaje] = useState('');

  const isRenewal = searchParams.get('tipo') === 'renovacion';

  useEffect(() => {
    const paymentId = searchParams.get('id');
    const clientTxId = searchParams.get('clientTransactionId');

    if (!paymentId || !clientTxId) {
      toast.error('No se recibieron datos de confirmación');
      navigate(isRenewal ? '/suscripcion/pagar' : '/register');
      return;
    }

    const confirmarPago = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_URL || '/api';
        const response = await axios.post(`${baseUrl}/payments/confirm-payment`, {
          paymentId,
          transactionId: clientTxId
        });

        if (response.data.success) {
          setStatus('success');
          setMensaje(response.data.message || '¡Pago exitoso!');

          if (isRenewal) {
            toast.success('✅ ¡Suscripción renovada! Redirigiendo...');
            // Refrescar datos del usuario en sessionStorage con el nuevo estado activo
            const token = sessionStorage.getItem('token');
            if (token) {
              try {
                const meResponse = await axios.get(`${baseUrl}/auth/me`, {
                  headers: { Authorization: `Bearer ${token}` }
                });
                sessionStorage.setItem('user', JSON.stringify(meResponse.data.user));
              } catch {}
            }
            setTimeout(() => navigate('/'), 3000);
          } else {
            toast.success('✅ ¡Pago exitoso! Tu cuenta ha sido activada.');
            setTimeout(() => navigate('/login'), 4000);
          }
        } else {
          setStatus('failed');
          setMensaje(response.data.error || 'Error al activar la cuenta');
          toast.error(response.data.error || 'Error al procesar el pago');
          setTimeout(() => navigate(isRenewal ? '/suscripcion/pagar' : '/register'), 4000);
        }
      } catch (error) {
        const errMsg = error.response?.data?.error || 'Error al procesar el pago';
        setStatus('failed');
        setMensaje(errMsg);
        toast.error(errMsg);
        setTimeout(() => navigate(isRenewal ? '/suscripcion/pagar' : '/register'), 4000);
      } finally {
        setLoading(false);
      }
    };

    confirmarPago();
  }, [searchParams, navigate, isRenewal]);

  // Estilos
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0f9ff 0%, #ffffff 50%, #eff6ff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '32px',
      padding: '3rem',
      textAlign: 'center',
      boxShadow: '0 25px 50px -12px rgba(59, 130, 246, 0.5)',
      maxWidth: '400px',
      width: '100%'
    },
    loading: {
      fontSize: '1.2rem',
      color: '#3b82f6',
      marginBottom: '1rem'
    },
    success: {
      color: '#065f46',
      backgroundColor: '#d1fae5',
      padding: '1rem',
      borderRadius: '12px'
    },
    error: {
      color: '#991b1b',
      backgroundColor: '#fee2e2',
      padding: '1rem',
      borderRadius: '12px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {loading && (
          <div style={styles.loading}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
            <div style={{ fontWeight: 600 }}>Procesando tu pago...</div>
            <div style={{ fontSize: '0.875rem', marginTop: '0.5rem', color: '#9ca3af' }}>
              No cierres esta ventana
            </div>
          </div>
        )}

        {status === 'success' && (
          <div style={styles.success}>
            <div style={{ fontSize: '3rem' }}>✅</div>
            <h3 style={{ margin: '0.75rem 0 0.5rem' }}>¡Pago Exitoso!</h3>
            <p style={{ margin: 0 }}>
              {isRenewal ? 'Tu suscripción ha sido renovada correctamente.' : 'Tu cuenta ha sido activada correctamente.'}
            </p>
            <p style={{ margin: '0.5rem 0 0', fontSize: '0.875rem', opacity: 0.8 }}>
              {isRenewal ? 'Redirigiendo al inicio en 3 segundos...' : 'Redirigiendo al login en 4 segundos...'}
            </p>
          </div>
        )}

        {status === 'failed' && (
          <div style={styles.error}>
            <div style={{ fontSize: '3rem' }}>❌</div>
            <h3 style={{ margin: '0.75rem 0 0.5rem' }}>Error en el Pago</h3>
            <p style={{ margin: 0 }}>{mensaje || 'No se pudo procesar tu pago.'}</p>
            <p style={{ margin: '0.5rem 0 0', fontSize: '0.875rem', opacity: 0.8 }}>
              Redirigiendo al registro en 4 segundos...
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutConfirm;